import React, { lazy } from 'react';
import { IMAGES } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
import { MegapackImage } from './MegapackImage';
export function PackComposite() {
  return <section className="py-16 md:py-24 bg-white px-4 overflow-hidden" data-id="element-170">
      <div className="max-w-5xl mx-auto text-center" data-id="element-171">
        <h2 className="text-3xl md:text-5xl font-extrabold text-stone-900 mb-4" data-id="element-172">
          Un sistema completo pensato per aiutarti a insegnare con più efficacia
        </h2>
        <p className="text-xl text-gray-600 mb-16 max-w-2xl mx-auto" data-id="element-173">
          Non un singolo manuale, ma un vero kit professionale per trasformare
          il tuo modo di preparare e vivere ogni lezione di tango.
        </p>

        <MegapackImage size="large" className="mt-4 md:mt-8" onClick={scrollToOffer} data-id="element-174" />
      </div>
    </section>;
}